export const REQUEST_ARTIST_CASE_STUDY = 'concrete/REQUEST_ARTIST_CASE_STUDY'
export const RECEIVE_ARTIST_CASE_STUDY = 'concrete/RECEIVE_ARTIST_CASE_STUDY'
export const ERROR_ARTIST_CASE_STUDY = 'concrete/ERROR_ARTIST_CASE_STUDY'



// WEBPACK FOOTER //
// ./src/components/artist-case-studies-container/action-types.js